module.exports = __webpack_public_path__ + "img/features-content-img-3-en.f1ed1da3.png";